<template>
	<div v-if="visible == 'customers'" class="panel panel-default">
		<loading :active="datatable.loading">
			<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
		</loading>
		<div class="panel-heading">{{ name }} | Total: {{ total }}
			<template v-if="total > 0">
				<div class="btn-group pull-right">
					<button @click="dataExport('pdf')" type="button" class="btn btn-default">
						<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
					</button>
					<button @click="dataExport('xls')" type="button" class="btn btn-default">
						<i class="fa fa-file-excel-o" aria-hidden="true"></i>
					</button>
				</div>
			</template>
		</div>
		<div class="panel-wrapper collapse in">
			<div class="panel-body">
				<div class="table-responsive">
					<datatable
						ref="datatable"
						:append-params="datatable.moreParams"
						:http-options="datatable.options"
						:css="datatable.css.table"
						:api-url="datatable.api"
						:fields="datatable.fields"
						:per-page="datatable.page"
						:pagination-path="datatable.path"
						:sort-order="datatable.sortOrder"
						@vuetable:pagination-data="onPaginationData"
						@vuetable:loading="loading"
						@vuetable:load-success="success"
						@vuetable:loaded="loaded">

						<template slot="id" slot-scope="props">
							<router-link
								:to="'customers/' + props.rowData.id">
								<template v-if="$platform.setting.customers.custom_reference">{{ props.rowData.reference }}</template>
								<template v-else>{{ props.rowData.id }}</template>
							</router-link>
						</template>

						<template slot="reference" slot-scope="props">
							<router-link
								:to="'customers/' + props.rowData.id">
								{{ props.rowData.reference }}
							</router-link>
						</template>

						<template slot="name" slot-scope="props">
							<router-link
								:to="'customers/' + props.rowData.id">
								{{ props.rowData.name }}
							</router-link>
						</template>

						<template slot="company" slot-scope="props">
							<template v-if="props.rowData.company">
								<router-link
									:to="'customers/' + props.rowData.id">
									{{ props.rowData.company }}
								</router-link>
							</template>
						</template>

						<template slot="address" slot-scope="props">
							<template v-if="props.rowData.places.length">
								<template v-if="props.rowData.places[0].google_place_id">{{ props.rowData.places[0].name }}</template>
								<template v-else>{{ props.rowData.places[0].formatted_address }}</template>
							</template>
						</template>

						<template slot="locality" slot-scope="props">
							<template v-if="props.rowData.places.length">
								<template v-if="props.rowData.places[0].locality">{{ props.rowData.places[0].locality }}</template>
							</template>
						</template>

						<template slot="administrative_area_level_2" slot-scope="props">
							<template v-if="props.rowData.places.length">
								<template v-if="props.rowData.places[0].administrative_area_level_2">{{ props.rowData.places[0].administrative_area_level_2 }}</template>
							</template>
						</template>

						<template slot="mobile" slot-scope="props">
							<a
								v-if="props.rowData.mobile"
								:href="'tel:' + props.rowData.mobile">
								{{ props.rowData.mobile }}
							</a>
						</template>

						<template slot="email" slot-scope="props">
							<a
								v-if="props.rowData.email"
								:href="'mailto:' + props.rowData.email">
								{{ props.rowData.email }}
							</a>
						</template>

						<template slot="referral" slot-scope="props">
							<template v-if="props.rowData.referral">{{ props.rowData.referral.name }}</template>
						</template>
					</datatable>

					<pagination-info ref="paginationInfo"
					:info-template="$t('interface.datatable.info_template')"
					:noDataTemplate="$t('interface.datatable.no_data_template')">
					</pagination-info>

					<div class="form-inline">
						<div class="form-group">
							<label class="control-label">{{ $t("interface.datatable.records_per_page") }}: </label>
							<div class="input-group">
								<select @change="reload" class="form-control" v-model="datatable.page">
									<option v-for="page in perPages" :value="page.value">{{ page.label }}</option>
								</select>
							</div>
						</div>
					</div>

					<pagination
						ref="pagination"
						:css="datatable.css.pagination"
						@vuetable-pagination:change-page="onChangePage">
					</pagination>
				</div>
			</div>
		</div>
		<div class="panel-footer"> Panel Footer </div>
	</div>
</template>

<script>
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	//--
	import VueElementLoading from 'vue-element-loading'
	import FileSaver from 'file-saver'

	export default {
		props: ['user', 'isAuth', 'visible'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			//--
			'loading': VueElementLoading,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/reports/customers',
					loading: true,
					moreParams: {
						filter: this.filter,
						export: {
							type: null,
						}
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: '#',
							sortField: 'id',
							visible: !this.$platform.setting.customers.custom_reference
						},
						{
							name: '__slot:reference',
							title: 'Ref.',
							sortField: 'reference',
							visible: this.$platform.setting.customers.custom_reference
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
						},
						{
							name: '__slot:name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:company',
							title: 'Empresa',
							sortField: 'company',
							visible: this.$platform.setting.customers.display_company
						},
						{
							name: '__slot:address',
							title: 'Dirección',
						},
						{
							name: '__slot:locality',
							title: 'Localidad',
						},
						{
							name: '__slot:administrative_area_level_2',
							title: 'Provincia',
						},
						{
							name: '__slot:mobile',
							title: 'Móvil',
							sortField: 'mobile',
						},
						{
							name: '__slot:email',
							title: 'E-mail',
							sortField: 'email',
						},
						{
							name: '__slot:referral',
							title: 'Referencia',
						},
					],
				},

				total: null,
				name: null,
			}
		},
		methods: {
			//-- Vuetable
				reload() {
					this.$nextTick( () => this.$refs.datatable.refresh())
				},
				loading() {
					this.datatable.loading = true
				},
				loaded() {
					this.datatable.loading = false
				},
				onPaginationData (paginationData) {
					this.$refs.paginationInfo.setPaginationData(paginationData)
					this.$refs.pagination.setPaginationData(paginationData)
				},
				onChangePage (page) {
					this.$refs.datatable.changePage(page)
				},
				success (response) {
					this.total = null
					this.name = null
					if(response) {
						if(response.data) {
							if(response.data.total) {
								this.total = response.data.total
							}
							if(response.data.name) {
								this.name = response.data.name
							}
						}
					}
				},
			//-- Vuetable
			setFilter(filter) {
				this.datatable.moreParams.filter = filter
			},
			dataExport(type) {
				var data = {
					filter: this.datatable.moreParams.filter,
					export: {
						type: type
					}
				}
				this.$http.get(this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/reports/customers', {params: data, responseType: 'blob'})
				.then(response => {
					var file = response.body
					var blob = new Blob([file], {type: type})
					var file_name = this.$options.filters.slugify(this.name) + '.' + type
					FileSaver.saveAs(blob, file_name)
				}).catch(function(response) {
					console.log(response)
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/reports/views/customers/Datatable.vue